export enum MerchantStatusType {
  Active = 1,
  Suspended = 2,
  FreeTier = 3,
}
